import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
	Row,
	Button,
	Form,
	Input,
	Dropdown,
	Menu,
	Image,
	Select,
	DatePicker,
} from "antd";
import AWS from "aws-sdk";
import moment from "moment";

import colorSyntax from "@toast-ui/editor-plugin-color-syntax";
import { Editor } from "@toast-ui/react-editor";
import Swal from "sweetalert2";

import longlifeApi from "../../../apis/Longlife.api";
import partnersApi from "../../../apis/Partners.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ApiService from "../../../utils/ApiService";
import { toastAlert } from "../../AlertComponent";

AWS.config.update({
	accessKeyId: process.env.REACT_APP_S3_ACCESSKEYID,
	secretAccessKey: process.env.REACT_APP_S3_SECRETACCESSKEY,
	region: process.env.REACT_APP_S3_REGION,
});

const s3 = new AWS.S3();
const api = new ApiService();

const EditCommunityLonglifeWriteComponent = ({
	setCommunityWriteShow,
	selectCommunity,
}) => {
	// const history = useHistory();
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const isLoading = useSelector((state) => state.common.loading);
	const editorRef = useRef(null);
	const cautionEditorRef = useRef(null);
	const inputRef = useRef(null);

	const toolbarItems = [
		["heading", "bold", "italic", "strike"],
		["link", "image"],
		// ['table', 'link'],
		// ['hr'],
		// ["table"],
		// ["ul", "ol"],
		// ['task', 'code'],
		["scrollSync"],
	];
	const editorHeight = "65vh";
	const someDuringList = ["일", "주", "개월", "년"];
	const repeatCountDuringList = ["회", "일", "주"];
	const categoryItemList = [
		{ label: "비교하기", value: "compare" },
		{ label: "영양 성분백과", value: "nutrition_encyclopedia" },
		{ label: "대상별", value: "age" },
		{ label: "증상별", value: "symptom" },
		{ label: "트렌드", value: "trend" },
		{ label: "선택기준", value: "selection" },
		{ label: "브랜드", value: "brand" },
		{ label: "기타", value: "etc" },
	];
	const targetAgeItems = [
		{ label: "0~2세", value: 0 },
		{ label: "2~13세", value: 1 },
		{ label: "0~13세", value: 2 },
		{ label: "청소년", value: 3 },
		{ label: "청소년부터 성인까지", value: 4 },
		{ label: "성인", value: 5 },
		{ label: "전 연령", value: 6 },
		// {label: "성인 여성", value: 7},
		// {label: "성인 남성", value: 8},
		{ label: "50세 이상", value: 9 },
		// {label: "50세 이상 남성", value: 10},
		// {label: "50세 이상 여성", value: 11},
		{ label: "임산부", value: 12 },
		{ label: "기타", value: 99 },
	];
	const contentReg = new RegExp(
		"font[ㄱ-ㅎ|ㅏ-ㅣ|가-힣0-9A-Za-z,.!;:\\)+\\-$&\\( ]*;",
		"g"
	);

	const [imageList, setImageList] = useState([]);
	const [photoList, setPhotoList] = useState([]);
	const [category, setCategory] = useState("event");
	const [mainCategoryList, setMainCategoryList] = useState([
		{ label: "클래스", value: "mission" },
		// { label: "건강 매거진", value: "health_magazine" },
		// { label: "공동구매", value: "cooperate" },
		{ label: "이벤트", value: "event" },
		{ label: "문의글", value: "recommend_nutrients" },
		// { label: "소통", value: "community", disabled: true },
		// { label: "피드", value: "feed" },
		// { label: "상세피드", value: "feedDetail" },
	]);
	const [categoryDetailList, setCategoryDetailList] = useState([]);
	// const [categoryDetail, setCategoryDetail] = useState();
	const [content, setContent] = useState({
		thumbnail: null,
		thumbnail_url: null,
		use_pedometer: null,
		category_id: null,
		sub_category: null,
		title: null,
		sub_title: null,
		body: null,
		repeat_type: 1,
		period_type: 1,
		is_reservation: false,
		reservation_date: moment(),
		seo_title: null,
		seo_author: "당신의 영양제",
		seo_description: null,
		seo_keywords: null,
		seo_image_alt: null,
	});
	const [biggestTitle, setBiggestTitle] = useState(0);
	const [disabledStatus, setDisabledStatus] = useState(true);
	const [preContentStatus, setPreContentStatus] = useState({
		cooperate: false,
		nutrients: false,
	});

	/**
	 * 공동구매
	 */
	const [selectCooperate, setSelectCooperate] = useState(null);
	const [selectCooperateId, setSelectCooperateId] = useState(null);

	/**
	 * 미션글일 경우 데이터
	 */
	const [during, setDuring] = useState(null);
	const [someDuring, setSomeDuring] = useState("주");
	const [repeatCount, setRepeatCount] = useState(null);
	const [repeatCountDuring, setRepeatCountDuring] = useState("일");
	const [usePedometer, setUsePedometer] = useState(false); // 만보기 사용 여부
	/**
	 * 건강 매거진일 경우 데이터
	 */
	const [symptomList, setSymptomList] = useState([]);

	/**
	 * 글 수정시 내용 셋팅 - ksb
	 */
	useEffect(async () => {
		existRecommendNutrientsContent();
		getNutrientSearchOption();
		if (!!selectCommunity && !!selectCommunity?.id && !!editorRef.current) {
			// let copyMainCateogoryList = [...mainCategoryList];
			// copyMainCateogoryList[0]["disabled"] = true;
			// setMainCategoryList(copyMainCateogoryList);
			setCategory(switchCategoryForEng(selectCommunity?.category));
			setContent({
				thumbnail: selectCommunity?.main_img_type,
				thumbnail_url: selectCommunity?.main_img_type
					? `${process.env.REACT_APP_S3_HOST}/image/contentMain/${selectCommunity?.id}.${selectCommunity.main_img_type}`
					: null,
				// use_pedometer: selectCommunity?.use_pedometer
				// 	? selectCommunity?.use_pedometer
				// 	: null,
				category_id:
					selectCommunity?.category !== "cooperate" &&
					selectCommunity?.category !== "event" &&
					selectCommunity?.category !== "recommend_nutrients"
						? selectCommunity?.category
						: null,
				sub_category:
					selectCommunity?.category === "age"
						? Number(selectCommunity?.sub_category)
						: selectCommunity?.sub_category,
				title: selectCommunity?.head_copy,
				sub_title: selectCommunity?.sub_copy,
				body: selectCommunity?.content,
				seo_title: selectCommunity?.seo_title,
				seo_author: selectCommunity?.seo_author,
				seo_description: selectCommunity?.seo_description,
				seo_keywords: selectCommunity?.seo_keywords,
				seo_image_alt: selectCommunity?.seo_image_alt,
				// repeat_type:
				// 	selectCommunity?.content_type === 0
				// 		? selectCommunity?.repeat_type
				// 		: 0,
				// period_type:
				// 	selectCommunity?.content_type === 0
				// 		? selectCommunity?.period_type
				// 		: 1,
			});
			editorRef.current?.getInstance().setHTML(selectCommunity?.content);
			if (selectCommunity?.imageList?.length) {
				let imgTitleList = [];
				for (let i = 0; i < selectCommunity?.imageList.length; i++) {
					const imgItem = selectCommunity?.imageList[i];
					imgTitleList.push(imgItem.title);
					if (i === selectCommunity?.imageList.length - 1) {
						const biggestNum = Number(imgItem.title.split("-")[1]);
						setBiggestTitle(biggestNum);
					}
				}
				setImageList(imgTitleList);
				setPhotoList(selectCommunity?.imageList);
			}
		}
	}, [selectCommunity, editorRef.current]);

	/**
	 * 피드, 상세피드, 미션, 소통글 카테고리 가져오기 - ksb
	 */
	useEffect(() => {
		if (category !== "health_magazine") {
			getCategoryList();
		}
		if (category === "cooperate" || category === "event") {
			getCooperateListForContent();
		}
	}, [category]);

	/**
	 * 등록하기 버튼 disabled 체크 - ksb
	 */
	useEffect(() => {
		checkDisabled();
	}, [category, content, during, repeatCount, usePedometer]);

	const getCategoryList = async () => {
		const param = {
			userId: user.id,
			categoryType: category,
		};
		const res = await longlifeApi.getCategoryList(param);
		if (res.code === 200) {
			let subCategoryListOptions = [];
			for (const categoryEl of res.result.categoryList) {
				const option = {
					label: categoryEl.category_name,
					value: categoryEl.id,
				};
				subCategoryListOptions.push(option);
			}
			setCategoryDetailList(subCategoryListOptions);
		} else {
			setCategoryDetailList([]);
		}
	};

	const [cooperateList, setCooperateList] = useState([]);

	const getCooperateListForContent = async () => {
		const param = {
			offset: 0,
			pageSize: 10,
			userId: user.id,
		};
		const res = await partnersApi.readGroupBuyingListForContent(param);
		if (res.code === 200) {
			setCooperateList(res.result?.cooperateList ?? []);
		}
	};

	const getNutrientSearchOption = async () => {
		setIsLoading(true);
		try {
			const param = {
				nutrients_id: "",
			};
			const res = await api.searchNutrientList(param);
			if (res.data.code === 200) {
				let effectList = [];
				for (const effectItem of res.data.result.nutrientEffectList) {
					const item = {
						label: effectItem.effect_name,
						value: effectItem.effect_id,
					};
					effectList.push(item);
				}
				setSymptomList(effectList);
			} else {
				setSymptomList([]);
				throw `효능 정보를 가져오기 못했습니다. 다시 시도해주시길 바랍니다.`;
			}
			setIsLoading(false);
		} catch (error) {
			setIsLoading(false);
			console.log("getNutrientSearchOption read error", error);
			alert(error);
		}
	};

	/**
	 * 기존에 작성한 추천 영양제 게시글이 있는지 여부 확인 (2023.10.13) - ksb
	 * @returns {Promise<void>}
	 */
	const existRecommendNutrientsContent = async () => {
		setIsLoading(true);
		try {
			const param = {
				userId: user.id,
			};
			const res = await api.checkRecommendNutrients(param);
			if (res.data.code === 200) {
				setPreContentStatus({
					cooperate: res.data.result?.check_cooperate,
					nutrients: res.data.result?.check_recommend_nutrients,
				});
			}
		} catch (e) {
			setIsLoading(false);
			console.log("existRecommendNutrientsContent read error", e);
		}
	};

	/**
	 * 미션글 미션 기간 - 몇 개월
	 * @type {JSX.Element}
	 */
	const dropdownMissionDuring = (
		<Menu>
			{someDuringList?.map((item, idx) => (
				<Menu.Item
					key={`category-${item?.id}-${idx}`}
					onClick={() => {
						setSomeDuring(item);
						setContent({ ...content, period_type: idx });
					}}
				>
					{item}
				</Menu.Item>
			))}
		</Menu>
	);

	/**
	 * 미션글 - 반복횟수 기준
	 * @type {JSX.Element}
	 */
	const dropdownMissionRelpeatDuring = (
		<Menu>
			{repeatCountDuringList?.map((item, idx) => (
				<Menu.Item
					key={`category-${item?.id}-${idx}`}
					onClick={() => {
						setRepeatCountDuring(item);
						setContent({ ...content, repeat_type: idx });
					}}
				>
					{item}
				</Menu.Item>
			))}
		</Menu>
	);

	/**
	 * 제목 열에 대한 값
	 * @param e
	 */
	const handleCommunityContent = (e) => {
		let { name, value } = e.target;
		if (category === "health_magazine" && name === "title") {
			setContent({
				...content,
				[name]: value,
				seo_title: value,
			});
		} else if (category === "health_magazine" && name === "sub_title") {
			setContent({
				...content,
				[name]: value,
				seo_description: value,
			});
		} else {
			setContent({
				...content,
				[name]: value,
			});
		}
	};

	/**
	 * 에디터 내 이미지 업로드 처리
	 * @param blob
	 * @param callback
	 * @returns {Promise<*>}
	 */
	const addImageBlobHook = async (blob, callback) => {
		const url = URL?.createObjectURL(blob);
		setPhotoList((photoList) => [...photoList, blob]);
		setImageList((imageList) => [...imageList, url]);
		return callback(url);
	};

	/**
	 * 프론트 내 업로드 버튼 클릭
	 */
	const onUploadImageClick = () => {
		if (!inputRef.current) {
			return;
		}
		inputRef.current.click();
	};

	/**
	 * 목록으로
	 */
	const goBackToCommunityList = () => {
		if (
			content.title?.length ||
			editorRef.current?.getInstance().getMarkdown()?.length
		) {
			Swal.fire({
				customClass: "alert-custom",
				text: `작성하던 글이 있습니다. 취소하시겠습니까?`,
				showCancelButton: true,
				confirmButtonText: "확인",
				cancelButtonText: "취소",
			}).then(async (result) => {
				if (result.isConfirmed) {
					setCommunityWriteShow(false);
					setContent({
						thumbnail: null,
						thumbnail_url: null,
						use_pedometer: null,
						category_id: null,
						title: null,
						sub_title: null,
						body: null,
					});
					setImageList([]);
					setPhotoList([]);
				}
			});
		} else {
			setCommunityWriteShow(false);
			setContent({
				thumbnail: null,
				thumbnail_url: null,
				use_pedometer: null,
				category_id: null,
				title: null,
				sub_title: null,
				body: null,
			});
			setImageList([]);
			setPhotoList([]);
		}
	};

	/**
	 * 매일건강 글 등록/수정하기 - ksb
	 * @returns {Promise<void>}
	 */
	const submitContent = () => {
		let alertText = "작성을 완료하고 적용하시겠습니까?";
		// 유효성 검사
		if (category === "mission") {
			if (
				!(
					category &&
					content.category_id &&
					content.title?.length &&
					(content.title ? content.title?.trim() : false) &&
					content.sub_title?.length &&
					(content.sub_title ? content.sub_title?.trim() : false) &&
					content.thumbnail &&
					during &&
					repeatCount &&
					(usePedometer ? content.use_pedometer : true) &&
					cautionEditorRef.current?.getInstance().getMarkdown()?.length &&
					editorRef.current?.getInstance().getMarkdown()?.length
				)
			) {
				toastAlert(
					"카테고리, 제목, 상세제목, 내용, 인증방법 및 주의사항, 미션기간 및 인증일수, 썸네일을 모두 선택/입력해주세요."
				);
				return;
			} else {
				let categoryName = "";
				const findIdx = categoryDetailList.findIndex(
					(categoryDetail) => categoryDetail.value === content.category_id
				);
				if (findIdx > -1) {
					categoryName = categoryDetailList[findIdx].label;
				}
				alertText = `${categoryName ? `[${categoryName}]` : ""}${
					content.title
				}\n미션기간: ${during}${someDuring}\n인증기간: ${repeatCount}${repeatCountDuring}\n\n 위의 내용으로 미션을 생성하시겠습니까?`;
			}
		} else if (category === "health_magazine") {
			if (
				!(
					category &&
					content.category_id &&
					(!!content.category_id &&
					(content.category_id === "age" || content.category_id === "symptom")
						? content.sub_category || content.sub_category === 0
						: true) &&
					content.title?.length &&
					(content.title ? content.title?.trim() : false) &&
					content.sub_title?.length &&
					(content.sub_title ? content.sub_title?.trim() : false) &&
					content.thumbnail &&
					editorRef.current?.getInstance().getMarkdown()?.length
				)
			) {
				toastAlert("카테고리, 제목, 내용, 썸네일을 모두 선택/입력해주세요.");
				return;
			}
		} else if (
			category === "cooperate" ||
			category === "event" ||
			category === "recommend_nutrients"
		) {
			if (
				!(category && editorRef.current?.getInstance().getMarkdown()?.length)
			) {
				toastAlert("내용을 입력해주세요.");
				return;
			}
			// else if (
			// 	category === "cooperate" &&
			// 	(selectCommunity?.id ? false : preContentStatus.cooperate)
			// ) {
			// 	toastAlert(
			// 		"진행예정중인 공동구매가 없거나 이미 공동구매 관련 게시글을 등록하셨습니다. 해당 글을 수정하시거나 관리자에게 문의해주시길 바랍니다."
			// 	);
			// 	return;
			// }
			else if (
				category === "recommend_nutrients" &&
				(selectCommunity?.id ? false : preContentStatus.nutrients)
			) {
				toastAlert(
					"이미 문의 관련 글을 등록했습니다. 해당 글을 수정해주시길 바랍니다."
				);
				return;
			}
		} else {
			if (
				!(
					category &&
					content.category_id &&
					content.title?.length &&
					(content.title ? content.title?.trim() : false) &&
					editorRef.current?.getInstance().getMarkdown()?.length
				)
			) {
				toastAlert("카테고리, 제목, 내용을 모두 선택/입력해주세요.");
				return;
			}
		}
		Swal.fire({
			customClass: "alert-custom",
			text: alertText,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setIsLoading(true);
				let type = "save";
				let editImageList = [];
				let editPhotoList = [];
				let contentTypeForInt;
				if (category === "mission") {
					contentTypeForInt = 0;
				} else if (category === "community") {
					contentTypeForInt = 1;
				} else if (category === "feed") {
					contentTypeForInt = 2;
				} else if (category === "feedDetail") {
					contentTypeForInt = 3;
				}
				let contentByTag = editorRef.current?.getInstance().getHTML();
				// 수정시 이미지 처리
				if (selectCommunity?.id) {
					let imgTitleListByContent = contentByTag.matchAll(
						/<img src=(")([\w{}/?.,;:|)*~!^\-_+<>@#$%&\\=(]+)\1/g
					);
					for (const regExpMatchImg of imgTitleListByContent) {
						const imgTitleList = regExpMatchImg[0].split('"');
						let findIdx = -1;
						if (regExpMatchImg[0].includes("blob:")) {
							findIdx = imageList.findIndex(
								(imageTitle) => imageTitle === imgTitleList[1]
							);
						} else {
							const splitted = regExpMatchImg[0].split("/");
							const findWord = splitted[splitted.length - 1].split(".")[0];
							findIdx = imageList.findIndex(
								(imageTitle) => imageTitle === findWord
							);
						}
						if (findIdx > -1) {
							editImageList.push(imageList[findIdx]);
							editPhotoList.push(photoList[findIdx]);
						}
					}
				} else {
					for (let i = 0; i < imageList.length; i++) {
						if (!contentByTag.includes(imageList[i])) {
							imageList.splice(i, 1);
							photoList.splice(i, 1);
						}
					}
				}
				let param = {
					category_id: content.category_id,
					content_type: contentTypeForInt,
					title: content.title,
					content: contentByTag
						.replaceAll(`<img class="ProseMirror-separator">`, "")
						.replaceAll(
							`contenteditable="false">`,
							`contenteditable="false" style="width: 100%;">`
						),
					created_by: user.id,
				};
				// 미션정보 입력시
				if (category === "mission") {
					const missonInfo = {
						thumbnail_img_type: content.thumbnail
							? content.thumbnail?.type?.split("/")[1]
							: null,
						sub_title: content.sub_title,
						caution: cautionEditorRef.current?.getInstance().getHTML(),
						use_pedometer: usePedometer ? content.use_pedometer : 0,
						repeat_time: repeatCount,
						repeat_type: content.repeat_type,
						period_time: during,
						period_type: content.period_type,
						is_reservation: content.is_reservation,
						reservation_date: content.is_reservation
							? content.reservation_date
							: null,
					};
					param = {
						...param,
						...missonInfo,
					};
				} else if (category === "health_magazine") {
					let magazineInfo;
					if (selectCommunity?.id) {
						magazineInfo = {
							channel_id: selectCommunity?.channel_id,
							is_exposure: selectCommunity?.is_exposure,
							top_banner: selectCommunity?.top_banner ?? null,
						};
					} else {
						magazineInfo = {
							is_best: false,
						};
					}
					magazineInfo = {
						...magazineInfo,
						category: content.category_id,
						sub_category: content.sub_category,
						main_img_type: content.thumbnail?.name
							? content.thumbnail?.type?.split("/")[1]
							: content.thumbnail,
						head_copy: content.title,
						sub_copy: content.sub_title,
						seo_title: content.seo_title,
						seo_author: content.seo_author,
						seo_description: content.seo_description,
						seo_keywords: content.seo_keywords,
						seo_image_alt: content.seo_image_alt,
						created_by:
							user?.role === "level_1" || user?.role === "super_admin"
								? user?.id
								: user?.partners_id,
					};
					param = {
						...param,
						...magazineInfo,
					};
				} else if (
					category === "cooperate" ||
					category === "event" ||
					category === "recommend_nutrients"
				) {
					const contentInfo = {
						category: category,
						is_best: false,
						created_by:
							user?.role === "level_1" || user?.role === "super_admin"
								? user?.id
								: user?.partners_id,
					};
					param = {
						...param,
						...contentInfo,
						cooperate_id: selectCooperateId,
					};
				}
				// 수정시
				if (selectCommunity?.id) {
					param["id"] = selectCommunity?.id;
					param["is_best"] = selectCommunity?.is_best ?? false;
					param["is_exposure"] = selectCommunity?.is_exposure ?? true;
					type = "edit";
				}

				let res;
				if (
					category === "health_magazine" ||
					category === "cooperate" ||
					category === "event" ||
					category === "recommend_nutrients"
				) {
					let magazineRes;
					// 수정시
					if (selectCommunity?.id) {
						magazineRes = await api.editContent(param);
					} else {
						magazineRes = await api.createContent(param);
					}
					res = magazineRes.data;
				} else {
					res = await longlifeApi.createContent(param);
				}
				if (res.code === 200) {
					addCommunityImageList(res.result, type, editPhotoList);
				} else if (res.code === 418) {
					if (category === "cooperate") {
						Swal.fire({
							customClass: "alert-custom",
							text: "진행예정중인 공동구매가 없거나 이미 공동구매 관련 게시글을 등록하셨습니다.\n해당 글을 수정하시거나 관리자에게 문의해주시길 바랍니다.",
							confirmButtonText: "확인",
						}).then(() => {
							console.log("cooperate-error");
							setIsLoading(false);
						});
					} else {
						Swal.fire({
							customClass: "alert-custom",
							text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
							confirmButtonText: "확인",
						}).then(() => {
							console.log("edit-error");
							setIsLoading(false);
						});
					}
				} else {
					Swal.fire({
						customClass: "alert-custom",
						text: "오류가 발생했습니다. 잠시 후 다시 시도해주세요.",
						confirmButtonText: "확인",
					}).then(() => {
						console.log("edit-error");
						setIsLoading(false);
					});
				}
			}
		});
	};

	/**
	 * 이미지 업로드
	 * @returns {Promise<void>}
	 * result: 결과값 -> id
	 * type: edit / save
	 */
	const addCommunityImageList = async (result, type, editPhotoList) => {
		let uploadFileList = [...photoList];
		let list = [];
		// 미션 썸네일 등록
		if (
			(category === "mission" || category === "health_magazine") &&
			content.thumbnail?.name
		) {
			uploadToS3(result, content.thumbnail, 0, "thumbnail");
		}
		if (type === "edit") {
			uploadFileList = editPhotoList;
		}
		for (let i = 0; i < uploadFileList?.length; i++) {
			let photo = uploadFileList[i];
			// 로컬에서만 등록한 이미지 파일
			if (!photo?.img_type) {
				uploadToS3(result, photo, i, null);
				let fileType = photo?.type?.split("/")[1];
				list.push({
					title: `${result?.id}-${biggestTitle + i + 1}`,
					img_type: fileType,
					url: `${
						process.env.REACT_APP_S3_LONGLIFE_HOST
					}/images/${category}/contents/${result?.id}/${result?.id}-${
						biggestTitle + i + 1
					}.${fileType}`,
				});
			} else {
				// 이미 S3에 업로드한 파일
				list.push({
					id: photo?.id,
					title: photo?.title,
					img_type: photo?.img_type,
					url: `${process.env.REACT_APP_S3_LONGLIFE_HOST}/images/${category}/contents/${result?.id}/${photo?.title}.${photo?.img_type}`,
				});
			}
		}

		const param = {
			id: result?.id,
			target_type: category,
			created_by:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			imageList: [...list],
		};
		const res = await longlifeApi.registerContentImageList(param);
		if (res.code === 200) {
			Swal.fire({
				customClass: "alert-custom",
				text: "성공적으로 적용되었습니다!",
				confirmButtonText: "확인",
			}).then(() => {
				setCommunityWriteShow(false);
				setIsLoading(false);
			});
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "오류가 발생했습니다. 잠시 후에 다시 시도해주세요.",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("image-list-error");
				setIsLoading(false);
			});
		}
	};

	/**
	 * 이미지 S3 업로드
	 * @param reviewId
	 */
	const uploadToS3 = async (result, photo, i, type) => {
		let fileType = photo?.type?.split("/")[1];
		let s3Path;
		if (type && type === "thumbnail") {
			if (category === "health_magazine") {
				s3Path = `image/contentMain/${result?.id}.${fileType}`;
			} else {
				s3Path = `images/${category}/${type}/${result?.id}.${fileType}`;
			}
		} else {
			s3Path = `images/${category}/contents/${result?.id}/${result?.id}-${
				biggestTitle + i + 1
			}.${fileType}`;
		}
		//aws-sdk 사용
		let params = {
			Bucket:
				category === "health_magazine" && type && type === "thumbnail"
					? process.env.REACT_APP_S3_BUCKETNAME
					: process.env.REACT_APP_S3_LONGLIFE_BUCKETNAME,
			Key: s3Path,
			Body: photo,
		};

		let res = await s3.putObject(params).promise();

		if (res.$response.httpResponse.statusCode === 200) {
			console.log("s3-upload-success");
		} else {
			Swal.fire({
				customClass: "alert-custom",
				text: "이미지 업로드 오류",
				confirmButtonText: "확인",
			}).then(() => {
				console.log("s3-upload-error");
				setIsLoading(false);
			});
		}
	};

	const checkDisabled = () => {
		if (category === "mission") {
			if (
				category &&
				content.category_id &&
				content.title?.length &&
				(content.title ? content.title?.trim() : false) &&
				content.sub_title?.length &&
				(content.sub_title ? content.sub_title?.trim() : false) &&
				content.thumbnail &&
				during &&
				repeatCount &&
				(usePedometer ? content.use_pedometer : true)
			) {
				setDisabledStatus(false);
			} else {
				setDisabledStatus(true);
			}
		} else if (category === "health_magazine") {
			if (
				category &&
				content.category_id &&
				(!!content.category_id &&
				(content.category_id === "age" || content.category_id === "symptom")
					? content.sub_category || content.sub_category === 0
					: true) &&
				content.title?.length &&
				(content.title ? content.title?.trim() : false) &&
				content.sub_title?.length &&
				(content.sub_title ? content.sub_title?.trim() : false) &&
				content.thumbnail
			) {
				setDisabledStatus(false);
			} else {
				setDisabledStatus(true);
			}
		} else if (
			category === "cooperate" ||
			category === "event" ||
			category === "recommend_nutrients"
		) {
			setDisabledStatus(false);
		} else {
			if (
				category &&
				content.category_id &&
				content.title?.length &&
				(content.title ? content.title?.trim() : false)
			) {
				setDisabledStatus(false);
			} else {
				setDisabledStatus(true);
			}
		}
	};

	/**
	 * 프론트 내 미션 썸네일 업로드 진행
	 * @param e
	 */
	const onUploadImage = (e) => {
		if (!e.target.files) {
			return;
		}
		const fileList = e.target.files;
		if (fileList?.length) {
			const fileUrl = URL?.createObjectURL(fileList[0]);
			setContent({
				...content,
				thumbnail: fileList[0],
				thumbnail_url: fileUrl,
			});
		}
	};

	/**
	 * 이미지 삭제
	 */
	const onDeleteImage = () => {
		Swal.fire({
			customClass: "alert-custom",
			text: `해당 이미지를 삭제하시겠습니까?`,
			showCancelButton: true,
			confirmButtonText: "확인",
			cancelButtonText: "취소",
		}).then(async (result) => {
			if (result.isConfirmed) {
				setContent({ ...content, thumbnail: null, thumbnail_url: null });
			}
		});
	};

	const switchCategoryForEng = (categoryId) => {
		switch (categoryId) {
			// case 0:
			// 	return "mission";
			// case 1:
			// 	return "community";
			// case 2:
			// 	return "feed";
			// case 3:
			// 	return "feedDetail";
			case "cooperate":
			case "recommend_nutrients":
				return categoryId;
			case "event":
				return categoryId;
			default:
				return "health_magazine";
		}
	};

	const disabledDate = (current) => {
		// Can not select days before today
		return current && current < moment().startOf("day");
	};

	const disabledDateTime = (selectDate) => {
		return {
			disabledHours: () =>
				selectDate && moment().format("YYMMDD") !== selectDate?.format("YYMMDD")
					? []
					: moment().get("H") !== 0
					? new Array(moment().get("H")).fill(0).map((_, idx) => idx)
					: [],
			disabledMinutes: () =>
				selectDate && moment().format("YYMMDD") !== selectDate?.format("YYMMDD")
					? []
					: selectDate
					? selectDate?.get("H") <= moment().get("H")
						? moment().get("m") !== 0
							? new Array(moment().get("m")).fill(0).map((_, idx) => idx)
							: []
						: []
					: moment().get("m") !== 0
					? new Array(moment().get("m")).fill(0).map((_, idx) => idx)
					: [],
		};
	};

	const handleReservationDate = (value, dateString) => {
		setContent({
			...content,
			reservation_date: value,
		});
	};

	return (
		<div className={`edit-community-write-div`}>
			{category === "health_magazine" && (
				<div className={`edit-community-write-sub-header`}>
					<p className={`title`}>
						카테고리/제목/썸네일<span className={`essential-star`}>*</span>
					</p>
				</div>
			)}
			<div className={`edit-community-write-header`}>
				<Select
					options={mainCategoryList}
					disabled={isLoading || !!selectCommunity?.id}
					value={category}
					onChange={(value) => {
						if (value !== category) {
							setContent({ ...content, category_id: null });
						}
						setCategory(value);
					}}
					style={{ width: "10em" }}
				/>
				{category !== "cooperate" &&
					category !== "event" &&
					category !== "recommend_nutrients" && (
						<Select
							options={
								category === "health_magazine"
									? categoryItemList
									: categoryDetailList
							}
							disabled={isLoading}
							placeholder={`${
								category !== "health_magazine" ? "상세 " : ""
							}카테고리`}
							value={content.category_id}
							onChange={(value) => {
								if (category === "health_magazine") {
									setContent({
										...content,
										category_id: value,
										sub_category: null,
									});
								} else {
									setContent({
										...content,
										category_id: value,
									});
								}
							}}
							style={{ width: "13em" }}
						/>
					)}

				{/*/!* 공동구매 선택하기*!/*/}
				{category === "cooperate" && (
					<Select
						options={cooperateList?.map((item, index) => ({
							...item,
							label: item.product_brand_name + " " + item.product_name,
							value: item.cooperate_id,
							key: index,
						}))}
						value={selectCooperate}
						placeholder={`공동구매를 선택해주세요`}
						onChange={(value, option) => {
							setSelectCooperateId(value);
							setSelectCooperate(option);
						}}
						style={{
							minWidth: "240px",
						}}
					/>
				)}

				{category === "health_magazine" ? (
					<Select
						options={
							content.category_id
								? content.category_id === "age"
									? targetAgeItems
									: content.category_id === "symptom"
									? symptomList
									: []
								: []
						}
						disabled={
							isLoading ||
							(content.category_id !== "age" &&
								content.category_id !== "symptom")
						}
						placeholder={"상세 카테고리"}
						value={content.sub_category}
						onChange={(value) =>
							setContent({ ...content, sub_category: value })
						}
						style={{ width: "100%" }}
					/>
				) : (
					category !== "cooperate" &&
					category !== "event" &&
					category !== "recommend_nutrients" && (
						<Input
							type={`text`}
							placeholder={`제목을 입력해주세요${
								category === "mission" ? " ex)헬스장 가기" : ""
							}`}
							name={"title"}
							value={content.title}
							onChange={handleCommunityContent}
							disabled={isLoading}
						/>
					)
				)}
			</div>

			{/* 공동구매 미리보기 */}
			{/*{category === "cooperate" && selectCooperate?.cooperate_id && (*/}
			{/*	<CooperatePreview selectCooperate={selectCooperate} />*/}
			{/*)}*/}

			{category === "health_magazine" && (
				<Row className={`edit-community-write-header`}>
					<p style={{ margin: 0, width: "100%" }}>헤드 카피</p>
					<Input
						type={`text`}
						placeholder={`제목을 입력해주세요`}
						name={"title"}
						value={content.title}
						onChange={handleCommunityContent}
						disabled={isLoading}
					/>
				</Row>
			)}

			{/*미션글에서 나타나는 추가 글*/}
			{category === "mission" || category === "health_magazine" ? (
				<>
					{category === "health_magazine" ? (
						<Row className={`edit-community-write-header`}>
							<p style={{ margin: 0, width: "100%" }}>서브 카피</p>
							<Input
								type={`text`}
								placeholder={`세부 제목을 입력해주세요`}
								name={"sub_title"}
								value={content.sub_title}
								onChange={handleCommunityContent}
								disabled={isLoading}
							/>
						</Row>
					) : (
						<div className={`edit-community-write-header`}>
							<Input
								type={`text`}
								placeholder={`세부 제목을 입력해주세요 ex)가벼운 스트레칭이라도 좋아요! 꾸준히 실천하는 멋진 나를 만나보세요!`}
								name={"sub_title"}
								value={content.sub_title}
								onChange={handleCommunityContent}
								disabled={isLoading}
							/>
						</div>
					)}
					<div className={`edit-community-image-div`}>
						{category === "mission" && (
							<p>
								썸네일<span className={`essential-star`}>*</span>
							</p>
						)}
						<div className={`edit-community-image-group`}>
							{content?.thumbnail ? (
								<Image.PreviewGroup>
									<div
										className={`image-preview-group`}
										style={{
											width: "15em",
											height: "15em",
											maxHeight: "15em",
										}}
									>
										<div
											className={`image-div`}
											style={{
												minWidth: "100%",
												maxWidth: "100%",
											}}
										>
											<Image
												preview={{
													mask: <></>,
												}}
												src={content?.thumbnail_url}
												alt={`건강 매거진 썸네일 이미지`}
											/>
											<img
												src={`/assets/images/channel/cancel.png`}
												alt={`이미지 삭제`}
												className={`image-delete-icon`}
												onClick={onDeleteImage}
											/>
										</div>
									</div>
								</Image.PreviewGroup>
							) : (
								<button
									className={`edit-profile-button`}
									style={{ padding: 0, width: "15em", height: "15em" }}
									onClick={onUploadImageClick}
									disabled={isLoading}
								>
									<input
										type="file"
										accept="image/*"
										style={{
											display: "none",
										}}
										ref={inputRef}
										onChange={onUploadImage}
									/>
									<img
										src={`/assets/images/channel/img-add.png`}
										onError={({ currentTarget }) => {
											currentTarget.onerror = null; // prevents looping
											// currentTarget.style.display = "none";
											currentTarget.src = `/assets/images/channel/img-add.png`;
										}}
										alt={`미션 썸네일 추가 버튼`}
									/>
								</button>
							)}
						</div>
					</div>
				</>
			) : (
				<></>
			)}

			{/*에디터*/}
			<Editor
				ref={editorRef}
				initialEditType={"wysiwyg"} // wysiwyg & markdown
				initialValue={""} // 글 수정 시 사용
				// initialValue={contentTitle.content || ""} // 글 수정 시 사용
				previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
				hideModeSwitch={true}
				theme={""} // '' & 'dark'
				usageStatistics={false}
				toolbarItems={toolbarItems}
				useCommandShortcut={true}
				plugins={[colorSyntax]}
				language="ko-KR"
				hooks={{
					addImageBlobHook: addImageBlobHook,
				}}
				height={editorHeight}
				onChange={() => {
					let contentText = editorRef.current?.getInstance().getHTML();
					if (contentReg.test(contentText)) {
						editorRef.current
							?.getInstance()
							.setHTML(contentText.replaceAll(contentReg, ""));
					}
				}}
			/>

			{/*미션일때 추가 정보 입력란*/}
			{category === "mission" && (
				<>
					<p style={{ marginBottom: 0 }}>
						인증방법 및 주의사항<span className={`essential-star`}>*</span>
					</p>
					<Editor
						ref={cautionEditorRef}
						initialEditType={"wysiwyg"} // wysiwyg & markdown
						initialValue={""} // 글 수정 시 사용
						// initialValue={contentTitle.content || ""} // 글 수정 시 사용
						previewStyle={window?.innerWidth > 1000 ? "vertical" : "tab"} // tab, vertical
						hideModeSwitch={true}
						theme={""} // '' & 'dark'
						usageStatistics={false}
						toolbarItems={toolbarItems}
						useCommandShortcut={true}
						plugins={[colorSyntax]}
						language="ko-KR"
						// hooks={{
						// 	addImageBlobHook: addImageBlobHook,
						// }}
						height={"30vh"}
					/>
					<div className={`edit-community-write-header`}>
						<label htmlFor="during">미션기간</label>
						<Input
							style={{ width: "25%" }}
							type="number"
							placeholder={`기간을 입력해주세요`}
							name={"during"}
							value={during}
							onChange={(e) => setDuring(e.target.value)}
							disabled={isLoading}
						/>
						<Dropdown
							overlay={dropdownMissionDuring}
							trigger={["click"]}
							disabled={isLoading}
						>
							<Button
								style={{
									display: "flex",
									alignItems: "center",
									gap: "3px",
									width: "10%",
									justifyContent: "space-between",
								}}
								disabled={isLoading}
							>
								{someDuring}
								<img
									src={`/assets/images/report/report-search-date-icon-down.png`}
									alt={`드롭다운`}
									style={{
										height: "auto",
										width: "0.8em",
									}}
								/>
							</Button>
						</Dropdown>
					</div>
					<div className={`edit-community-write-header`}>
						<label htmlFor="repeatCount">인증기간</label>
						<Input
							style={{ width: "25%" }}
							type="number"
							placeholder={`반복횟수를 입력해주세요.`}
							name={"repeatCount"}
							value={repeatCount}
							onChange={(e) => setRepeatCount(e.target.value)}
							disabled={isLoading}
						/>
						<Dropdown
							overlay={dropdownMissionRelpeatDuring}
							trigger={["click"]}
							disabled={isLoading}
						>
							<Button
								style={{
									display: "flex",
									alignItems: "center",
									gap: "3px",
									width: "10%",
									justifyContent: "space-between",
								}}
								disabled={isLoading}
							>
								{repeatCountDuring}
								<img
									src={`/assets/images/report/report-search-date-icon-down.png`}
									alt={`드롭다운`}
									style={{
										height: "auto",
										width: "0.8em",
									}}
								/>
							</Button>
						</Dropdown>
					</div>
					<div className={`edit-community-write-header`}>
						<Input
							type="number"
							id="checkbox"
							disabled={!usePedometer}
							placeholder={"목표 횟수"}
							value={content.use_pedometer}
							onChange={(e) =>
								setContent({ ...content, use_pedometer: e.target.value })
							}
							style={{
								width: "10em",
							}}
						/>
						<input
							type="checkbox"
							id="pedometer_count"
							value={usePedometer}
							onClick={() => setUsePedometer(!usePedometer)}
						/>
						<label htmlFor="checkbox">만보기 사용 여부</label>
					</div>
					<div className={`edit-community-write-header`}>
						<input
							type="checkbox"
							id="is_reservation"
							value={content.is_reservation}
							onClick={() =>
								setContent({
									...content,
									is_reservation: !content.is_reservation,
								})
							}
						/>
						<label htmlFor="checkbox">예약설정</label>
						<DatePicker
							// format={"YYYY년 MM월 DD일"}
							// value={genderAge.age}
							onChange={handleReservationDate}
							allowClear={false}
							disabled={!content.is_reservation}
							disabledDate={disabledDate}
							disabledTime={disabledDateTime}
							showTime
						/>
					</div>
				</>
			)}

			{/*건강 매거진일때 추가 정보 입력란*/}
			{category === "health_magazine" && (
				<>
					<div className={`edit-community-write-sub-header`}>
						<p className={`title`}>SEO</p>
					</div>
					<div className={`edit-community-form-wrap`}>
						<Form.Item
							className="center-label pre-line"
							label={"브라우저 타이틀\n:Title"}
							labelAlign="left"
							colon={false}
							labelCol={{ span: 3 }}
							wrapperCol={{ span: 21 }}
						>
							<Input
								name="seo_title"
								value={content.seo_title}
								onChange={handleCommunityContent}
							/>
						</Form.Item>
						<Form.Item
							className="center-label pre-line"
							label={"메타태그1\n:Author"}
							labelAlign="left"
							colon={false}
							labelCol={{ span: 3 }}
							wrapperCol={{ span: 21 }}
						>
							<Input
								name="seo_author"
								value={content.seo_author}
								onChange={handleCommunityContent}
							/>
						</Form.Item>
						<Form.Item
							className="product-register-form-input-wrap pre-line"
							label={"메타태그2\n:Description"}
							labelAlign="left"
							colon={false}
							labelCol={{ span: 3 }}
							wrapperCol={{ span: 21 }}
						>
							<Input.TextArea
								name="seo_description"
								value={content.seo_description}
								onChange={handleCommunityContent}
								style={{ resize: "none", minHeight: 110 }}
							/>
						</Form.Item>
						<Form.Item
							className="pre-line"
							label={"메타태그3\n:Keywords"}
							labelAlign="left"
							colon={false}
							labelCol={{ span: 3 }}
							wrapperCol={{ span: 21 }}
						>
							<Input.TextArea
								name="seo_keywords"
								value={content.seo_keywords}
								onChange={handleCommunityContent}
								style={{ resize: "none", minHeight: 110 }}
							/>
							<div className={`input-help-text`}>
								- 키워드는 콤마(,)로 구분하여 입력합니다.
							</div>
						</Form.Item>
						<Form.Item
							label="상품 이미지 Alt 텍스트"
							labelAlign="left"
							colon={false}
							labelCol={{ span: 3 }}
							wrapperCol={{ span: 21 }}
						>
							<Input
								name="seo_image_alt"
								value={content.seo_image_alt}
								onChange={handleCommunityContent}
							/>
							<div className={`input-help-text`}>
								- Alt 텍스트는 해당 상품을 표현할 수 있는 1개 ~ 2개 정도의
								단어로 입력하세요.
							</div>
						</Form.Item>
					</div>
				</>
			)}

			<div className={`order-component-each insight-button-group`}>
				<Button onClick={goBackToCommunityList} loading={isLoading}>
					목록으로
				</Button>
				<Button
					className="product-register-button save"
					onClick={submitContent}
					loading={isLoading}
					disabled={disabledStatus}
					style={{
						marginLeft: "1rem",
					}}
				>
					{selectCommunity?.id ? "수정완료" : "작성완료"}
				</Button>
			</div>
		</div>
	);
};

const CooperatePreview = ({ selectCooperate }) => {
	return (
		<div
			style={{
				border: "solid 1px #ced4da",
				borderRadius: 5,
				padding: "1em",
				display: "flex",
				gap: "2em",
			}}
		>
			<img
				src={
					selectCooperate?.product_id
						? `${process.env.REACT_APP_CDN}/image/recommend/${selectCooperate?.target_id}.jpg`
						: `${process.env.REACT_APP_CDN}/image/together/group_buying/${selectCooperate?.target_id}.jpg`
				}
				onError={({ currentTarget }) => {
					currentTarget.onerror = null; // prevents looping
					// currentTarget.style.display = "none";
					currentTarget.src = `/assets/images/no-product.png`;
				}}
				alt={`${selectCooperate?.product_brand_name} ${selectCooperate?.product_name}`}
				style={{
					width: 150,
					height: 150,
					objectFit: "contain",
				}}
			/>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
				}}
			>
				<p
					style={{
						margin: 0,
						fontSize: "1em",
						fontWeight: 500,
						letterSpacing: -0.8,
						color: "#868e96",
					}}
				>
					{moment(selectCooperate?.cooperate_start_date)?.format(
						"YYYY.MM.DD HH:mm"
					)}{" "}
					~{" "}
					{moment(selectCooperate?.cooperate_end_date)?.format(
						"YYYY.MM.DD HH:mm"
					)}
				</p>
				<p style={{ fontWeight: "bold", fontSize: "1.3em" }}>
					{selectCooperate?.product_brand_name} >{" "}
					{selectCooperate?.product_name}
				</p>
				<p style={{ margin: 0, fontWeight: 500, fontSize: "1em" }}>
					- {selectCooperate?.usp}
				</p>
				<p style={{ margin: 0, fontSize: "1em" }}>
					- {selectCooperate?.information_1}
				</p>
				<p style={{ margin: 0, fontSize: "1em" }}>
					- {selectCooperate?.information_2}
				</p>
				<p style={{ margin: 0, fontSize: "1em" }}>
					- {selectCooperate?.information_3}
				</p>
			</div>
			<div
				style={{
					marginLeft: "auto",
					backgroundColor: selectCooperate?.related_content
						? "#117ffa"
						: "#adb5bd",
					borderRadius: 8,
					display: "flex",
					height: "fit-content",
					padding: "0.3em 1em",
				}}
			>
				<p
					style={{
						margin: 0,
						fontSize: "1em",
						fontWeight: 500,
						color: "white",
					}}
				>
					{selectCooperate?.related_content ? "작성완료" : "미작성"}
				</p>
			</div>
		</div>
	);
};

export default EditCommunityLonglifeWriteComponent;
